<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Iniciar Sesión</h1>
                <p class="text-muted">Ingrese a su cuenta de productor / organizador</p>
                <b-alert :show="sessionExpired" variant="warning">Su sesión ha expirado. Ingrese nuevamente.</b-alert>
                <b-form-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Código de productor u organizador (agente)"
                      autocomplete="off"
                      v-model="user.cod_agente"
                      @blur="$v.user.cod_agente.$touch"
                      :state="$v.user.cod_agente.$dirty ? !$v.user.cod_agente.$error : null"
                    />
                  </b-input-group>
                </b-form-group>
                <b-form-group class="input-password">
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      class="form-control"
                      placeholder="Contraseña"
                      autocomplete="current-password"
                      v-model="user.password"
                      @blur="$v.user.password.$touch"
                      :state="$v.user.password.$dirty ? !$v.user.password.$error : null"
                      @keyup.enter="login"
                    />
                  </b-input-group>
                </b-form-group>
                <b-row class="align-items-center">
                  <b-col md="5">
                    <b-button class="btn-action d-md-none" variant="link" to="/password/email"> Olvidé mi contraseña </b-button>
                    <b-button variant="primary" class="px-4 btn-action" @click="login">Aceptar</b-button>
                  </b-col>
                  <b-col md="7" class="text-right">
                    <b-button class="btn-action d-none d-md-block" variant="link" to="/password/email"> Olvidé mi contraseña </b-button>
                    <hr  class="d-lg-none"/>
                    <b-button variant="link" class="d-lg-none btn-register text-center" to="/signup">Regístrese en el nuevo sistema</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width: 44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Registro</h2>
                  <p>Obtenga su clave de acceso y opere con nuestro sistema exclusivo para productores y organizadores.</p>
                  <b-button variant="primary" class="active mt-3" to="/signup">Regístrese Ahora</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';
import validarCuit from '@/helpers/ValidacionCuit';

export default {
  name: 'Login',
  data() {
    return {
      user: {
        cod_agente: '',
        password: '',
      },
    };
  },
  computed: {
    sessionExpired() {
      return Object.keys(this.$route.query).some((key) => key === 'sessionExpired');
    },
  },
  validations: {
    user: {
      cod_agente: { required },
      password: { required, minLength: minLength(8) },
    },
  },
  methods: {
    login: async function () {
      this.$v.user.$touch();

      if (this.$v.user.$invalid) {
        this.$toast.error('Complete los campos requeridos.', 'Error');
        return null;
      }

      let loader = this.$loading.show();

      let identificador = 'codigo';

      if (validarCuit(this.user.cod_agente)) {
        identificador = 'cuit';
      } else if (this.user.cod_agente.indexOf('@') > -1) {
        identificador = 'email';
      }

      await this.$api
        .post('auth/login?identificador=' + identificador, this.user)
        .then((res) => {
          if (res.data.access_token) {
            this.$store.commit('setAuth', res.data);
            this.$router.push('/');
          } else {
            this.$router.push(`/signup/${this.user.cod_agente}`);
          }
        })
        .catch((e) => {
          if (e.response.data.code){
            if (e.response.data.code == 1000)
              this.$toast.error('Login incorrecto, revise la contraseña ingresada. Si no la recuerda vaya a “Olvide mi contraseña”', 'Error');
            else if (e.response.data.code == 1001)
                    this.$toast.error('Usuario inexistente. Registrese para poder ingresar', 'Error');
          }
                  
          //this.$toast.error('Login incorrecto, revise los datos ingresados. Si es la primera vez que intenta acceder al sistema nuevo deberá registrarse.', 'Error');
        });
      loader.hide();
    },
  },
};
</script>


<style scoped>
@media (max-width: 768px) {
  .btn-action {
    width: 100%;
  }

  .btn-register {
    color: #fff;
    background-color: #1985ac;
    border-color: #187da0;
    margin-top: 10px;
    padding: 12px;
    display: block;
  }
  .input-password {
    margin-bottom: 0;
  }
}
</style>